import { useAuthentication } from '@/components/auth/AuthProvider'
import useLocalStorageUIDotDev from './useLocalStorageUIDotDev'

export default function useLocalStorage<T>(key: string, initialValue: T) {
  const { user } = useAuthentication()
  const fullKey = `${key}-${user?.id || 'logged-out'}`

  return useLocalStorageUIDotDev(fullKey, initialValue)
}
